import { getApiCall, postApiCall } from "../utils/request";
import { returnErrors } from "./errorAction";
import {
    GET_TESTS, GET_OLD_TESTS, CHECK_TEST, TEST_HISTORY, NEXT_TEST_HISTORY, GET_CERTIFICATE, GET_REPORT
} from '../actionType/type';



export const getTests = () => async (dispatch) => {
    try {
        const response = await getApiCall(`user/test/details`);
        const data = response.data.data
        dispatch({ type: GET_TESTS, payload: data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const checkTest = (id) => async (dispatch) => {
    try {

        var response = await getApiCall(`user/test/check?skill_id=${id}`);
        const data = response.data
        dispatch({ type: CHECK_TEST, payload: data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getOldCretificates = () => async (dispatch) => {
    try {
        const response = await getApiCall(`user/test/v1/list`);
        const data = response.data.data
        dispatch({ type: GET_OLD_TESTS, payload: data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getCertData = (id, type) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/test/certificate?_id=${id}&type=${type}`);
        const data = response.data.data
        dispatch({ type: GET_CERTIFICATE, payload: data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getReportData = (id, user) => async (dispatch) => {
    try {
        var response
        if (user === 'admin') {
            response = await getApiCall(`admin/test/report?_id=${id}`);
        } else {
            response = await getApiCall(`user/test/report?_id=${id}`);
        }
        const data = response.data.data
        dispatch({ type: GET_REPORT, payload: data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const orderedTests = (id) => async (dispatch) => {
    let obj = {
        _id: id
    }
    try {
        const response = await postApiCall(`user/test/request`, obj);
        if (response.data.success) {
            returnErrors(dispatch, 'Test has been requested', response?.status);
        } else {
            returnErrors(dispatch, response?.data.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}


export const getTestHistory = (page) => async (dispatch) => {
    try {

        var response = await getApiCall(`user/test/results?page=${page}`);
        const data = response.data.data
        dispatch({ type: TEST_HISTORY, payload: data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getNextHistory = (page) => async (dispatch) => {
    try {

        var response = await getApiCall(`user/test/results?page=${page}`);
        const data = response.data.data
        dispatch({ type: NEXT_TEST_HISTORY, payload: data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

